import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { Box } from 'components/Box';
import { Button } from 'components/Button';
import HeaderWithCloseLabel from 'components/HeaderWithCloseLabel/HeaderWithCloseLabel.component';
import Icon from 'components/Icon/Icon.component';
import greenCheckCircle from 'images/icons/green_check_circle.svg';
import { bankUploadEndCallbackSchema } from 'pages/upload-info-pages/bank/bank.types';
import { Translate } from 'react-localize-redux';
import { Text } from 'style/text.style';
import z from 'zod';

const bankInfoSuccessSchema = z.object({
  endCallback: bankUploadEndCallbackSchema.optional(),
});

export const Route = createFileRoute('/upload-bank-info-success')({
  validateSearch: zodValidator(bankInfoSuccessSchema),
  component: UploadBankInfoSuccess,
});
function UploadBankInfoSuccess() {
  const navigate = Route.useNavigate();
  const search = Route.useSearch();

  const closeTo = search.endCallback === 'RECHARGE' ? '/topup' : '/';

  const handleClose = () => {
    navigate({ to: closeTo });
  };
  return (
    <>
      <HeaderWithCloseLabel closeLink={closeTo} headerHeight="40px" />

      <Box
        display={'flex'}
        justifyContent={'center'}
        width={'100vw'}
        height={'100vh'}
        backgroundColor="#fff"
      >
        <Box
          maxWidth={604}
          width={'100%'}
          margin={'0 auto'}
          display={'flex'}
          padding={'48px 16px'}
          flexDirection={'column'}
          gap="24px"
        >
          <Box
            padding={16}
            border={'1px solid rgba(191, 191, 191, 1)'}
            borderRadius={8}
            display={'flex'}
            flexDirection={'column'}
          >
            <Icon
              margin="0 auto"
              iconSize={'56px'}
              height={'56px'}
              iconSrc={greenCheckCircle}
            />
            <Text textSize={'18px'} textWeight={600} margin={'24px 0 8px 0'}>
              <Translate id="lbl.uploadSuccessful" />
            </Text>
            <Text textSize={'14px'}>
              <Translate id="lbl.ibanDocumentSubmitted" />
            </Text>
          </Box>
          <Button onClick={handleClose} marginLeft={'auto'}>
            <Translate id="lbl.close" />
          </Button>
        </Box>
      </Box>
    </>
  );
}
